"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("./icons/fontawesome.css");

require("./icons/solid.css");

require("./icons/regular.css");

require("./icons/brands.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AwIcon = function AwIcon(props) {
  var iconName = props.iconName,
      className = props.className,
      style = props.style,
      onClick = props.onClick;


  return _react2.default.createElement(
    "div",
    {
      style: style,
      className: className,
      onClick: onClick
    },
    _react2.default.createElement("i", { className: "fas fa-" + iconName })
  );
};

exports.default = AwIcon;